<template>
  <v-card class="pa-0" v-if="optionsAccordingUser.length > 0">
    <v-list dense class="base-modal__divider py-0">
      <v-list-item
        :key="key"
        v-for="(item, key) of optionsAccordingUser"
        class="px-0 white"
      >
        <button
          class="options-post__button"
          @click="$emit('open', item.action)"
        >
          {{ item.name }}
        </button>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script lang="ts">
import { MiniProfile } from "@/modules/profile/types";
import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";
import i18n from "@/plugins/i18n";
@Component
export default class OptionsPost extends Vue {
  @Prop(Object) profile: MiniProfile;
  @Prop(Boolean) isPost: boolean;
  @Prop(Boolean) isComment: boolean;
  @Prop(Boolean) canFixed: boolean;
  @Prop(Boolean) isRepost: boolean;
  @Prop(Boolean) canReadMode: boolean;
  @Prop(Boolean) isRead: boolean;
  @Prop(Boolean) isWhitePaper: boolean;
  @Prop(Boolean) showOriginal: boolean;
  @Prop(Boolean) isCommunity: boolean;
  @Prop(Boolean) isRoundTable: boolean;
  @Prop(Boolean) canFixMention: boolean;
  @Prop(Boolean) canMakeVisible: boolean;
  @Prop(Boolean) isSuccessCase: boolean;
  @Prop(Boolean) isModal: boolean;
  @Prop(Boolean) canFixCase: boolean;
  @Prop(Boolean) tabCase: boolean;
  @Prop(Boolean) isMostComment: boolean;
  @Prop(Boolean) isSurveyMonkey: boolean;
  @Prop(Boolean) fixed: boolean;
  @Prop(Boolean) fixPostLounge: boolean;
  @Prop(Boolean) unfixPostLounge: boolean;
  @Prop(Boolean) tabMention: boolean;
  @Prop({ default: () => [] }) fixes: any;
  hovered = "";
  optionsItems = [
    {
      name: i18n.t("timeline.openCommunity"),
      action: "openCommunity",
    },
    {
      name: i18n.t("mocks.openPost"),
      action: "modal",
    },
    {
      name: i18n.t("post.openOriginalPost"),
      action: "openOriginal",
    },
    {
      name: i18n.t("mocks.openProfile"),
      action: "profile",
    },
    {
      name: i18n.t("misc.editPost"),
      action: "edit",
    },
    {
      name: i18n.t("mocks.editComment"),
      action: "editComment",
    },
    {
      name: i18n.t("mocks.deletePost"),
      action: "deletePost",
    },
    {
      name: i18n.t("mocks.deleteComment"),
      action: "deleteComment",
    },
    {
      name: i18n.t("misc.fixPost"),
      action: "fixPost",
    },
    // {
    //   name: i18n.t("post.unfixPost"),
    //   action: "unfixPost",
    // },
    {
      name: i18n.t("mocks.denounceComment"),
      action: "denounceComment",
    },
    {
      name: i18n.t("mocks.denouncePost"),
      action: "denouncePost",
    },
    {
      name: i18n.t("modal.modalInativePostButton"),
      action: "inative",
    },
    {
      name: i18n.t("settings.inactivateComment"),
      action: "inativeComment",
    },
    {
      name: i18n.t("readingList.readMode"),
      action: "readMode",
    },
    {
      name: i18n.t("readingList.removeReadMode"),
      action: "removeReadMode",
    },
    {
      name: i18n.t("timeline.copyLink"),
      action: "copyLink",
    },
    {
      name: i18n.t("roundTable.copyLink"),
      action: "copyLinkRoundTable",
    },
    {
      name: i18n.t("post.fixPostLounge"),
      action: "fixPostLounge",
    },
    {
      name: i18n.t("post.unfixPostLounge"),
      action: "unfixPostLounge",
    },
    // {
    // name: i18n.t("post.fixMention"),
    // action: "fixMention",
    // },
    // {
    // name: i18n.t("post.unfixMention"),
    // action: "unfixMention",
    // },
    {
      name: i18n.t("profile.hideMention"),
      action: "hideMention",
    },
    // {
    // name: i18n.t("post.fixCase"),
    // action: "fixCase",
    // },
    // {
    // name: i18n.t("post.unfixCase"),
    // action: "unfixCase",
    // },
    {
      name: i18n.t("profile.hideCase"),
      action: "hideCase",
    },
    {
      name: i18n.t("post.makeVisibleTimeline"),
      action: "makeVisibleTimeline",
    },
    {
      name: i18n.t("post.removeVisibility"),
      action: "removeVisibility",
    },
  ];
  @State((state) => state.profile.me) me: any;
  get optionsAccordingUser(): any {
    return this.optionsItems.filter((x: any) => this.showOptions(x));
  }
  showOptions(item: any): any {
    return (
      (item.action !== "edit" ||
        (item.action === "edit" &&
          this.profile.id === this.me.id &&
          ((this.me.role === "FOUR_NETWORK" &&
            this.me.permissions.includes("POST_UPDATE")) ||
            this.me.role !== "FOUR_NETWORK") &&
          !this.isComment)) &&
      (item.action !== "inative" ||
        (item.action === "inative" &&
          this.me.role === "FOUR_NETWORK" &&
          this.me.permissions.includes("POST_INATIVATE") &&
          this.profile.id !== this.me.id &&
          !this.isComment)) &&
      (item.action !== "modal" || (item.action === "modal" && this.isPost)) &&
      (item.action !== "profile" ||
        (item.action === "profile" &&
          this.profile.id !== this.me.id &&
          !["profileHome", "profileCLevel", "profileMarketing"].includes(
            String(this.$route.name)
          ))) &&
      (item.action !== "editComment" ||
        (item.action === "editComment" &&
          this.profile.id === this.me.id &&
          ((this.me.role === "FOUR_NETWORK" &&
            this.me.permissions.includes("COMMENT_SAVE")) ||
            this.me.role !== "FOUR_NETWORK") &&
          !this.isMostComment &&
          this.isComment)) &&
      (item.action !== "inativeComment" ||
        (item.action === "inativeComment" &&
          this.me.permissions.includes("COMMENT_INATIVATE") &&
          this.me.role === "FOUR_NETWORK" &&
          this.profile.id !== this.me.id &&
          this.isComment)) &&
      (item.action !== "deleteComment" ||
        (item.action === "deleteComment" &&
          this.me.permissions.includes("COMMENT_DELETE") &&
          this.profile.id === this.me.id &&
          this.isComment)) &&
      (item.action !== "denounceComment" ||
        (item.action === "denounceComment" &&
          this.me.role !== "FOUR_NETWORK" &&
          this.profile.id !== this.me.id &&
          this.profile.role !== "FOUR_NETWORK" &&
          this.isComment)) &&
      (item.action !== "denouncePost" ||
        (item.action === "denouncePost" &&
          this.me.role !== "FOUR_NETWORK" &&
          this.profile.id !== this.me.id &&
          this.profile.role !== "FOUR_NETWORK" &&
          !this.isWhitePaper &&
          !this.isComment)) &&
      (item.action !== "deletePost" ||
        (item.action === "deletePost" &&
          this.profile.id === this.me.id &&
          ((this.me.role === "FOUR_NETWORK" &&
            this.me.permissions.includes("POST_DELETE") &&
            !this.isSurveyMonkey) ||
            this.me.role !== "FOUR_NETWORK") &&
          !this.isComment)) &&
      (item.action !== "fixPost" ||
        (item.action === "fixPost" &&
          ((this.me.role === "FOUR_NETWORK" &&
            this.me.permissions.includes("POST_FIX_SAVE")) ||
            this.me.role !== "FOUR_NETWORK") &&
          this.fixes &&
          this.fixes.filter((fix: any) => fix.canFix).length > 0 &&
          (this.me.role === "MARKETING" || this.me.role === "FOUR_NETWORK"
            ? !this.isModal
            : this.isPost) &&
          !this.isComment)) &&
      // (item.action !== "unfixPost" ||
      //   (item.action === "unfixPost" &&
      //     this.fixes &&
      //     this.fixes.filter((fix: any) => !fix.canFix && fix.status).length >
      //       0 &&
      //     this.me.role === "FOUR_NETWORK" &&
      //     this.me.permissions.includes("POST_FIX_SAVE") &&
      //     this.isPost)) &&
      (item.action !== "openOriginal" ||
        (item.action === "openOriginal" &&
          this.isPost &&
          this.isRepost &&
          this.showOriginal)) &&
      (item.action !== "readMode" ||
        (item.action === "readMode" &&
          this.profile.id !== this.me.id &&
          (this.me.role === "MARKETING" ||
            ["PARTICIPANT", "PARTNER", "EXECUTIVE", "EQUIPE"].includes(
              this.me.role
            )) &&
          !this.isRead &&
          this.isPost)) &&
      (item.action !== "removeReadMode" ||
        (item.action === "removeReadMode" &&
          this.profile.id !== this.me.id &&
          (this.me.role === "MARKETING" ||
            ["PARTICIPANT", "PARTNER", "EXECUTIVE", "EQUIPE"].includes(
              this.me.role
            )) &&
          this.isRead &&
          this.isPost)) &&
      (item.action !== "openCommunity" ||
        (item.action === "openCommunity" &&
          this.isPost &&
          this.isCommunity &&
          this.$route.name !== "communityHome")) &&
      (item.action !== "copyLink" ||
        (item.action === "copyLink" && !this.isComment)) &&
      (item.action !== "copyLinkRoundTable" ||
        (item.action === "copyLinkRoundTable" &&
          !this.isComment &&
          this.isRoundTable)) &&
      (item.action !== "fixMention" ||
        (item.action === "fixMention" &&
          this.$route.name === "profileHome" &&
          this.profile.id !== this.me.id &&
          this.canFixMention &&
          this.tabCase &&
          this.me.role === "MARKETING")) &&
      (item.action !== "unfixMention" ||
        (item.action === "unfixMention" &&
          this.$route.name === "profileHome" &&
          this.profile.id !== this.me.id &&
          !this.canFixMention &&
          this.tabCase &&
          this.me.role === "MARKETING")) &&
      (item.action !== "hideMention" ||
        (item.action === "hideMention" &&
          this.$route.name === "profileHome" &&
          this.profile.id !== this.me.id &&
          this.me.role === "MARKETING" &&
          this.tabMention)) &&
      (item.action !== "fixCase" ||
        (item.action === "fixCase" &&
          this.$route.name === "profileHome" &&
          this.profile.id !== this.me.id &&
          this.canFixCase &&
          this.isSuccessCase &&
          this.tabCase &&
          this.me.role === "MARKETING")) &&
      (item.action !== "unfixCase" ||
        (item.action === "unfixCase" &&
          this.$route.name === "profileHome" &&
          this.profile.id !== this.me.id &&
          !this.canFixCase &&
          this.tabCase &&
          this.isSuccessCase &&
          this.me.role === "MARKETING")) &&
      (item.action !== "hideCase" ||
        (item.action === "hideCase" &&
          this.$route.name === "profileHome" &&
          this.profile.id !== this.me.id &&
          this.me.role === "MARKETING" &&
          this.tabCase)) &&
      (item.action !== "makeVisibleTimeline" ||
        (item.action === "makeVisibleTimeline" &&
          this.me.role === "FOUR_NETWORK" &&
          this.$route.name === "readingListSuccessCase" &&
          this.me.permissions.includes("SUCCESS_CASE_PRIORITIZATION_SAVE") &&
          this.canMakeVisible &&
          this.isSuccessCase)) &&
      (item.action !== "removeVisibility" ||
        (item.action === "removeVisibility" &&
          this.me.role === "FOUR_NETWORK" &&
          this.$route.name === "readingListSuccessCase" &&
          this.me.permissions.includes("SUCCESS_CASE_PRIORITIZATION_SAVE") &&
          !this.canMakeVisible &&
          this.isSuccessCase)) &&
      (item.action !== "fixPostLounge" ||
        (item.action === "fixPostLounge" && this.fixPostLounge)) &&
      (item.action !== "unfixPostLounge" ||
        (item.action === "unfixPostLounge" && this.unfixPostLounge))
    );
  }
}
</script>
<style lang="sass" scoped>
.options-post__button
  display: flex
  align-items: center
  width: 100%
  padding: 8px 16px
  border: none
  outline: none
  background: transparent
  cursor: pointer
  font-weight: 700
  font-size: 14px
  line-height: 20px
  color: var(--v-gray70-base)
  text-align: left
  transition: background 0.3s ease, color 0.3s ease

  &:hover
    color: var(--v-purple100-base)

  &:active
    background: var(--v-purplePale-base)
    color: var(--v-purpleBrand-base)

  &:focus-visible
    border: 1px solid var(--v-tealFocus-base)
    outline: none
</style>
